import { render, staticRenderFns } from "./data-view-page.vue?vue&type=template&id=1a0c4146&scoped=true"
import script from "./data-view-page.vue?vue&type=script&lang=js"
export * from "./data-view-page.vue?vue&type=script&lang=js"
import style0 from "./data-view-page.vue?vue&type=style&index=0&id=1a0c4146&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0c4146",
  null
  
)

export default component.exports